// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "TwoColumnHeroWithImageRight-module--backgroundContainmentImage--0410c";
export var elevatedContainmentImage = "TwoColumnHeroWithImageRight-module--elevatedContainmentImage--f0fb0";
export var innerImage = "TwoColumnHeroWithImageRight-module--innerImage--f7009";
export var innerWrapper = "TwoColumnHeroWithImageRight-module--innerWrapper--cc2b8";
export var normalContainmentImage = "TwoColumnHeroWithImageRight-module--normalContainmentImage--b5160";
export var pigsNose = "TwoColumnHeroWithImageRight-module--pigsNose--109f6";